import { useCallback } from 'react';
import { useSearchParams } from 'next/navigation';

import { inIframe, sendToParent } from '@lyearn/core/utils/iframe';
import useAnalytics from '@/components/Analytics/hooks/useAnalytics';
import { useAppConfig } from '@/hooks/useAppConfig';
import useNavigation from '@/hooks/useNavigation';
import useQueryParam, { StringParam } from '@/hooks/useQueryParam';
import routes from '@/pages/corporate/routes';

import { PARENT_ENTITY_ID } from '../../exercise/views/Details/utils';

export default function useArticleNavigation() {
  const navigation = useNavigation();
  const navigate = useNavigation();
  const searchParams = useSearchParams();
  const { track } = useAnalytics();
  const { ui } = useAppConfig();
  const [parentEntityId] = useQueryParam(PARENT_ENTITY_ID, StringParam);

  const onBack = useCallback(
    (source?: string) => {
      if (inIframe() && !ui.isIFrameBackAllowed) {
        return sendToParent(JSON.stringify({ action: 'BackPressed', source: source }));
      }

      if (parentEntityId) {
        // const params = new URLSearchParams(searchParams.toString());
        navigate.replace(routes.PathDetails(parentEntityId), { appendQuery: false });
        track('Course Back button Clicked');
      } else {
        navigation.back();
        track('Course Back button Clicked');
      }
    },
    [navigate, navigation, parentEntityId, track, ui.isIFrameBackAllowed],
  );

  return { onBack };
}
